<template>
  <div class="contain">
    <van-popup
        v-model="isShow"
        position="bottom"
        :style="{ height: '70%' }"
        @click-overlay="onClose"
        :close-on-click-overlay="false"
    >
      <div class="search-box">
        <van-search placeholder="请输关键字搜索" v-model="keywords" @input="onSearch" />
                <van-field
                    v-if="false"
                    readonly
                    clickable
                    name="area"
                    :value="formData.city?formData.province+'/'+formData.city:''"
                    input-align="right"
                    label="省市选择"
                    placeholder="点击选择省市"
                    @click="showArea = true"
                />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              :columns-num="2"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>
      </div>
      <div style="height:44px"></div>
      <div class="user-box">
        <van-cell-group>
          <van-cell
              v-for="(item, index) in options"
              clickable
              :label="(item.sex)+' '+item.grade+' '+item.num_str+' '+item.namekeyhtml "
              :key="index"
              @click="toggle(item)"
              :v-if="index < limit"
          >
            <template slot="title">
              <div class="custom-title">{{item.name}}</div>
            </template>
            <van-checkbox
                v-model="item.checked"
                slot="right-icon"
                checked-color="#FD2840"
            />
          </van-cell>
        </van-cell-group>
      </div>
      <div class="createbtn">
        <van-button type="danger" size="large" @click="onConfirm">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import area from "../../utils/area";
import {
  Popup,
  Toast,
  Cell,
  CellGroup,
  Icon,
  Search,
  Checkbox,
  CheckboxGroup
} from "vant";

Vue.use(Popup)
    .use(Toast)
    .use(Cell)
    .use(CellGroup)
    .use(Icon)
    .use(Search)
    .use(Checkbox)
    .use(CheckboxGroup);

export default {
  name: "JianduPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },

    limit: {
      type: Number,
      default: 1
    },

    defaultValue: {
      type: Array,
      default: () => []
    },

  },
  data() {
    return {
      isShow: false,
      showArea: false,
      result: [],
      list:[],
      area: '',
      areaList: {},
      keywords: "",
      formData: {

      }
    };
  },
  computed:{
    options(){
      let that = this;
      this.list.map((item,index) =>{
        if(that.resultIds.indexOf(item.id) ==-1){
          item.checked = false;
        }else{
          item.checked = true;
        }
      })

      return [...this.list];
    },
    resultIds(){
      return this.result.map((item,index) =>{
        return item.id
      })
    }
  },
  mounted() {
  },
  watch: {
    show(value) {
      this.isShow = value;
      if(value){
        this.areaList = area
        this.onSearch();
        this.result = [...this.defaultValue];
      }
    },
    result(value){
      this.$emit("onChange",value);
    },

  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },

    onAreaConfirm(values) {
      console.log(values);
      this.area = values[1].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      // this.formData.county = values[2].name;
      this.showArea = false;

      this.onSearch()
    },

    toggle(item) {
      console.log('toggle',item.checked);
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            Toast('最多不能超过'+(this.limit)+'个');
            return ;
          }
        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.id != item.id
        });
      }
    },
    onSearch() {
      let that = this;
      that.$api.get(
          "/api/jiandu/jianduOptions",
          { keywords: this.keywords, area: this.area },
          res => {
            that.list = [...res.data];
          }
      );
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    }
  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
.search-box {
  position: fixed;
  z-index: 999;
  width: 100%;
}
.van-search__content {
  background: #efeff4;
}

.user-box {
  margin-bottom: 50px;
}

.createbtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// JianduPicker.vue?fd8ff27a